import React, { useEffect, useRef, useState } from "react";
import "../styles/cookiebanner.css";

const CONSENT_KEY = "cookieConsent";
const CONSENT_VERSION = "v2"; // bump to re-prompt after changes

const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
      if (!stored || stored.version !== CONSENT_VERSION) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    if (open && cardRef.current) cardRef.current.focus();
  }, [open]);

  const save = (value) => {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({ value, version: CONSENT_VERSION, ts: Date.now() })
    );
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      className="cb-layer"
      role="dialog"
      aria-live="polite"
      aria-label="Süti hozzájárulás"
    >
      <div className="cb-card" tabIndex={-1} ref={cardRef}>
        <div className="cb-text">
          <h2 className="cb-title">Sütik használata</h2>
          <p>
            Ez a weboldal sütiket használ a felhasználói élmény javításához. A
            böngészés folytatásával elfogadja a sütik használatát.{" "}
            <a
              className="cb-link"
              href="/adatvedelem"
              target="_blank"
              rel="noopener noreferrer"
            >
              Részletek az adatkezelésről
            </a>
            .
          </p>
        </div>

        <div className="cb-actions">
          <button
            className="cb-btn cb-btn-outline"
            onClick={() => save("declined")}
          >
            Elutasítom
          </button>
          <button
            className="cb-btn cb-btn-primary"
            onClick={() => save("accepted")}
          >
            Elfogadom
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
